import useAchievements from '@/hooks/useAchievements';
import { FC } from 'react';
import CollectionCompleteVideo from '../Videos/CollectionCompleteVideo/CollectionCompleteVideo';
import AchievementsOverview from './AchievementsOverview';

export const AchievementsPage: FC = () => {
	const achievements = useAchievements();

	return (
		<main>
			<CollectionCompleteVideo />
			<AchievementsOverview {...achievements} isInsideDialog={false} />
		</main>
	);
};
